/**
 * Drag-and-drop type identifiers for the Month View. Kept in their own file
 * so both `useDrag` and `useDrop` consumers (`EventChip`, `DayCell`) can
 * import the same constant without forming a circular dependency.
 */
export const EVENT_DRAG_TYPE = 'CALENDAR_MONTH_EVENT';
